export const noticias = [
  {
    id: 1,
    titulo: "San Isidro se prepara para el Lollapalooza",
    img: "/img/sani/image4.jpeg",
    img2: "/img/sides/_APP1123.jpg",
    fecha: "13-03-2026",
    contenido: "El festival más grande de la región vuelve este fin de semana con una renovación total del predio: nuevos recorridos, tres escenarios reubicados y un Perry’s Stage inmersivo. Desde este viernes 13 hasta el domingo 15 de marzo, el Hipódromo de San Isidro volverá a ser el epicentro musical del país. La organización rediseñó parte del predio para mejorar la circulación, reubicando tres de los cinco escenarios principales y trasladando el Kidzapalooza a una zona más central. Habrá operativos especiales de tránsito en los alrededores.",
    ciudad: "San Isidro"
  },
  {
    id: 2,
    titulo: "Murió “Pipo” Marín: el hombre más poderoso del fútbol de San Isidro",
    img: "/img/sani/image3.jpg",
    img2: "/img/sides/_APP2120_Original.jpg",
    fecha: "12-03-2026",
    contenido: "Alfil de Claudio Tapia y artífice del histórico ascenso de Club Atlético Acassuso al Nacional B, Javier “Pipo” Marín fue una figura clave en la estructura dirigencial del fútbol argentino. Su historia refleja la del propio Acassuso: un club que bajo su órbita pasó de pelear en las categorías más bajas a alcanzar la segunda división del fútbol local. Fue un dirigente decisivo en los pasillos de la AFA y su muerte ha sacudido tanto al mundo del deporte como a la comunidad de San Isidro.",
    ciudad: "San Isidro"
  },
  {
    id: 3,
    titulo: "Llovió en San Isidro y las imágenes fueron virales",
    img: "/img/sani/image5.png",
    img2: "/img/sides/_APP2295.jpg",
    fecha: "12-03-2026",
    contenido: "Tras las intensas precipitaciones registradas en la zona, diversos usuarios compartieron imágenes y videos que se volvieron tendencia rápidamente en redes sociales, mostrando el impacto del clima en la ciudad.",
    ciudad: "San Isidro"
  },
  {
    id: 4,
    titulo: "Vuelven las “Nochecitas en el Río” a San Isidro",
    img: "/img/sani/image1.jpg",
    img2: "/img/sides/_APP5173.jpg",
    fecha: "12-03-2026",
    contenido: "El Municipio organiza una nueva edición del evento con gastronomía, emprendedores locales y música en vivo junto al río. Se realizará este viernes de 19 a 23 horas en Roque Sáenz Peña y el río. La propuesta busca aprovechar las noches de verano en un espacio recuperado frente a la costa. La música estará a cargo de DJ Los Vinilos, Agus Quena, Las Vocat y la banda Ensalada de Covers.",
    ciudad: "San Isidro"
  },
  {
    id: 5,
    titulo: "San Isidro conquista la costa del Río de la Plata",
    img: "/img/sani/image2.jpg",
    img2: "/img/sides/_APP5441.jpg",
    fecha: "12-03-2026",
    contenido: "La Provincia de Buenos Aires cederá unas 50 hectáreas de tierras costeras al municipio para ampliar el acceso público al río. El acuerdo permitirá incorporar espacios verdes, senderos y áreas recreativas, reforzando el vínculo histórico de la ciudad con la ribera. Esta medida busca la recuperación y apertura de nuevos sectores para el disfrute de vecinos y visitantes.",
    ciudad: "San Isidro"
  },
  {
    id: 6,
    titulo: "El nuevo empresario de San Miguel: Carlito’ apuesta fuerte al padel local", 
    img: "/img/sanmig/1.png",
    img2: "/img/sides/_APP5444.jpg",
    fecha: "17-03-2026",
    contenido: "Carlos Tévez desembarca en San Miguel con su nuevo proyecto deportivo: una academia de pádel ubicada en Pardo y Av. León Gallardo. El espacio, que se encuentra en sus etapas finales de construcción, buscará formar jugadores y brindar herramientas para la vida. El plan contempla abrir otras dos sedes en el futuro.",
    ciudad: "San Miguel"
  },
  {
    id: 7,
    titulo: "Vecino destaca la seguridad en San Miguel en LN+", 
    img: "/img/sanmig/2.png",
    img2: "/img/sides/_APP6319.jpg",
    fecha: "17-03-2026",
    contenido: "En una entrevista para el canal LN+, un vecino comparó la situación de seguridad en la provincia respecto al municipio, señalando que en San Miguel los controles son constantes y se detiene a quienes circulan de forma sospechosa, a diferencia de otras zonas.",
    ciudad: "San Miguel"
  },
  {
    id: 8,
    titulo: "Vecinos cortaron una avenida para ver a Los Manseros Santiagueños", 
    img: "/img/sanmig/3.png",
    img2: "/img/sides/_APP6728.jpg",
    fecha: "17-03-2026",
    contenido: "Ni piquete ni protesta: en un hecho inusual, el público en San Miguel interrumpió el tránsito en una avenida principal con el único objetivo de disfrutar de la presentación de Los Manseros Santiagueños.",
    ciudad: "San Miguel"
  },
  {
    id: 9,
    titulo: "El mural más hermoso de San Miguel", 
    img: "/img/sanmig/4.png",
    img2: "/img/sides/_APP8269.jpg",
    fecha: "17-03-2026",
    contenido: "Ubicado en la esquina de Pichincha y Av. Dr. Ricardo Balbín, este mural impulsado por la empresa Proquality representa distintas especies de animales. La obra emociona a los vecinos, quienes asocian los elementos del paisaje con el 'cielo de los perros', recordando a sus mascotas que ya no están.",
    ciudad: "San Miguel"
  },
  {
    id: 10,
    titulo: "Vecina ganó el premio nacional de Literatura",
    img: "/img/sanmig/5.png",
    img2: "/img/sides/_APP8286.jpg",
    fecha: "17-03-2026",
    contenido: "Belén Checchi Chale obtuvo el primer premio en Poesía del XIX Concurso Nacional de Cuento y Poesía 'Adolfo Bioy Casares'. Su obra, titulada 'A dónde regresa un río', fue seleccionada entre 170 libros presentados de todo el país por un jurado de referentes literarios.",
    ciudad: "San Miguel"
  },
  {
    id: 11,
    titulo: "Noche histórica con sabor amargo: Platense cayó ante Corinthians",
    img: "/img/vicent/image1.jpg",
    img2: "/img/sides/_APP2120_Original.JPG",
    fecha: "09-04-2026",
    contenido: "En una noche histórica para el club, Platense hizo su debut en la Copa Libertadores ante Corinthians en un estadio Ciudad de Vicente López repleto. El Calamar fue mejor en el primer tiempo, generó las chances más claras y mereció irse al descanso en ventaja. Pero en el complemento, Corinthians salió con más intensidad y Yuri Alberto marcó dos veces para sellar el 2-0 final. El próximo partido será ante Peñarol en Uruguay el 16 de abril.",
    ciudad: "Vicente Lopez"
  },
  {
    id: 12,
    titulo: "Vicente López se convierte en la capital del running con el 10K Adidas",
    img: "/img/vicent/image2.jpg",
    img2: "/img/sides/_APP2295.jpg",
    fecha: "12-04-2026",
    contenido: "Este domingo 12 de abril, el 10K Adidas Supernova organizado por Ñandú marca el inicio de la temporada alta de running 2026 en Vicente López. La largada es a las 8 desde Laprida y Vial Costero. Los kits se retiran en el Centro de Convenciones Arturo Frondizi e incluyen remera oficial y dorsal. El circuito está certificado y para muchos runners representa el pistoletazo de salida del año competitivo.",
    ciudad: "Vicente Lopez"
  },
  {
    id: 13,
    titulo: "Festival solidario en FATE por los trabajadores despedidos",
    img: "/img/sanFer/image3.jpg",
    img2: "/img/sides/_APP5441.jpg",
    fecha: "12-04-2026",
    contenido: "El cierre de la histórica planta de neumáticos Fate en San Fernando dejó a 920 familias sin trabajo. En respuesta, los trabajadores organizan un festival solidario este domingo 12 de abril desde las 15 horas en Blanco Encalada 3001, Victoria. La jornada contará con shows de Nonpalidece, Malandro y Los Gedes con entrada libre y gratuita para visibilizar el reclamo.",
    ciudad: "San Fernando"
  },
  {
    id: 14,
    titulo: "Repudio por agresión a estudiantes en acto por el Día de la Memoria",
    img: "/img/sanFer/Captura de pantalla 2026-04-10 183042.png",
    img2: "/img/sides/_APP5444.jpg",
    fecha: "24-03-2026",
    contenido: "Durante un acto estudiantil en conmemoración del Día de la Memoria en San Fernando, un hombre identificado como militante libertario y simpatizante del nazismo agredió a cadenazos a jóvenes mientras gritaba consignas a favor de Milei. El incidente fue filmado y el video se viralizó rápidamente en redes sociales, generando un rechazo generalizado de la comunidad.",
    ciudad: "San Fernando"
  },
  {
    id: 15,
    titulo: "Nordelta vuelve a ser viral por los outfits de sus vecinos",
    img: "/img/tigre/Captura de pantalla 2026-04-10 183245.png",
    img2: "/img/sides/_APP8269.jpg",
    fecha: "08-04-2026",
    contenido: "La esencia del barrio Nordelta, registrada a través de las vestimentas de sus residentes, se volvió viral en redes sociales tras una publicación de 'Algo de Tigre'. El contenido, que analiza los estilos locales en Instagram y TikTok, capturó rápidamente la atención de los usuarios.",
    ciudad: "Tigre"
  },
  {
    id: 16,
    titulo: "Tigre debutó en la Sudamericana con un valioso empate en Perú",
    img: "/img/tigre/image4.png",
    img2: "/img/sides/_APP6728.jpg",
    fecha: "07-04-2026",
    contenido: "El Matador inició su camino en la Copa Sudamericana igualando 1-1 ante Alianza Atlético de Sullana en Perú. Ignacio Russo fue el autor del gol para el equipo dirigido por Diego Dabove. Con este resultado, Tigre suma su primer punto internacional del año. Ahora, el equipo se prepara para enfrentar a Atlético Tucumán por el torneo local este domingo.",
    ciudad: "Tigre"
  },
  
];